<script setup lang="ts">
const emit = defineEmits<{
    cancel: [];
    confirm: [];
}>();

const { $lrud } = useNuxtApp();
const emitterLrud = $lrud.emitter;

const onCancel = () => emit('cancel');

const onRegister = async (event: any) => {
    await nextTick();
    $lrud.assignFocus(event);
};

const onCallbackHandkeKey: Parameters<typeof emitterLrud.on>[0] = ({ direction }) => {
    if (direction === 'back') {
        onCancel();
        emitterLrud.stop();
    }
};

onBeforeMount(() => {
    emitterLrud.on(onCallbackHandkeKey);
});

onBeforeUnmount(() => {
    emitterLrud.off(onCallbackHandkeKey);
});
</script>

<template>
    <PopupBase>
        <div class="popup-exit-confirm">
            <div class="popup-exit-confirm__text">
                <p>Вы действительно хотите выйти?</p>
            </div>
            <LrudNode class="popup-exit-confirm__btns" orientation="horizontal" :parent="$lrud.base.rootNode.id">
                <LrudNode isFocusable defaultFocus @selected="onCancel" @register="onRegister">
                    <ButtonBase class="popup-exit-confirm__btn" @click="onCancel">Нет</ButtonBase>
                </LrudNode>
                <LrudNode isFocusable @selected="emit('confirm')">
                    <ButtonBase class="popup-exit-confirm__btn" @click="emit('confirm')">Да</ButtonBase>
                </LrudNode>
            </LrudNode>
        </div>
    </PopupBase>
</template>

<style lang="scss" scoped>
.popup-exit-confirm {
    display: flex;
    flex-direction: column;
    height: 100%;

    &__text {
        flex: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: #d0d0d0;
        font-size: px(40);
        line-height: 1.25;

        p {
            margin: 0;
        }
    }

    &__btns {
        flex: auto;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        gap: px(36);
    }

    &__btn {
        width: px(260);
        background-color: transparent;
        outline: px(4) solid $main-black;

        .lrud_focused & {
            outline: px(4) solid $blue;
        }
    }
}
</style>
